export interface ICustomPage {
  customPageId: number;
  name: string;
  slug: string;
  isActive: boolean;
  hasNavigationRules: boolean;
}

export enum SectionType {
  GENERIC_SECTION = 'GenericSection',
  HEADER = 'Header',
  FOOTER = 'Footer',
  YOU_TUBE_VIDEO_SECTION = 'YouTubeVideoSection',
  ACCORDION_SECTION = 'AccordionSection',
  ACCORDION_ITEM = 'AccordionItem',
  BUTTON_LINK = 'ButtonLink',
  LINK_BLOCK_SECTION = 'LinkBlockSection',
  VIDEO_ITEM = 'VideoItem',
  Mobile_App_Section = 'MobileAppSection',
  HERO = 'HeroSection',
  IFRAME = 'IFrameSection'
}

export type SectionTypeValue =
  | 'GenericSection'
  | 'Header'
  | 'Footer'
  | 'AccordionSection'
  | 'AccordionItem'
  | 'ButtonLink'
  | 'LinkBlockSection'
  | 'YouTubeVideoSection'
  | 'VideoItem'
  | 'MobileAppSection'
  | 'HeroSection'
  | 'IFrameSection';

export interface ICustomPageSection {
  customPageSectionId: number | null;
  parentCustomPageSectionId: number | null;
  name: string | null;
  type: SectionTypeValue;
  text: string | null;
  subText: string | null;
  imageText: string | null;
  imageUrl: string | null;
  linkText: string | null;
  linkUrl: string | null;
  sortOrder: number;
  hasError?: boolean;
  sections?: ICustomPageSection[];
  sectionClass?: string;
  hasLoadedSubSections?: boolean;
  parentSectionId?: number;
  iFrameSrc?: string;
}

export interface ICustomPageUpdate {
  name: string;
  slug: string;
  isActive: boolean;
  navigationType: string;
  customNavigationId: number | null;
  sections: ICustomPageSection[];
}

export interface ICustomPageDetail {
  customPageId: number;
  name: string;
  slug: string;
  isActive: boolean;
  customNavigationId: number | null;
  navigationType: string;
  sections: ICustomPageSection[];
}
